import {getRestProps} from '../utils';

export default function(obj, _Vdt, blocks, $callee) {
    _Vdt || (_Vdt = Vdt);
    obj || (obj = {});
    blocks || (blocks = {});
    var h = _Vdt.miss.h, hc = _Vdt.miss.hc, hu = _Vdt.miss.hu, widgets = this && this.widgets || {}, _blocks = {}, __blocks = {},
        __u = _Vdt.utils, extend = __u.extend, _e = __u.error, _className = __u.className, __slice = __u.slice, __noop = __u.noop,
        __m = __u.map, __o = __u.Options, _getModel = __o.getModel, _setModel = __o.setModel,
        _setCheckboxModel = __u.setCheckboxModel, _detectCheckboxChecked = __u.detectCheckboxChecked,
        _setSelectModel = __u.setSelectModel,
        self = this.data, $this = this, scope = obj, Animate = self && self.Animate, parent = ($callee || {})._super;

    const {
    value, _list, disabled, disable,
    _translate, _marginTop, _dragging
} = self.get();

const classNameObj = {
    "k-scroll-select": true, 
    "k-dragging": _dragging,
    "k-disabled": disabled,
}

    return h('div', {
        ...function() {try {return (getRestProps(self) )} catch(e) {_e(e)}}.call($this)
    }, [
        h('div', {
            'style': function() {try {return ({
            transform: `translateY(${_translate}px)`,
            marginTop: `${_marginTop}px`,
        } )} catch(e) {_e(e)}}.call($this),
            'ev-mousedown': function() {try {return (!disabled ? self._dragStart : undefined )} catch(e) {_e(e)}}.call($this),
            'ev-wheel': function() {try {return (!disabled ? self._onWheel : undefined )} catch(e) {_e(e)}}.call($this)
        }, __m(function() {try {return (_list )} catch(e) {_e(e)}}.call($this), function(item, key) {
            return h('div', {
                'ev-click': function() {try {return (!disabled ? self._select.bind(self, item, key) : undefined )} catch(e) {_e(e)}}.call($this)
            }, function() {try {return (item.label )} catch(e) {_e(e)}}.call($this), _className(function() {try {return ({
                "k-scroll-item": true,
                "k-active": item.value === value,
                "k-disabled": disabled || disable && disable.call(self, item.value), 
            } )} catch(e) {_e(e)}}.call($this)), function() {try {return (item.key )} catch(e) {_e(e)}}.call($this), function() {try {return (key === 0 ? (dom) => self.refs.item = dom : undefined )} catch(e) {_e(e)}}.call($this));
        }, $this), 'k-wrapper', null, function(i) {widgets['wrapper'] = i}),
        function() {try {return (blocks.append )} catch(e) {_e(e)}}.call($this) ?
            h('div', null, (_blocks['append'] = function(parent) {
                return null;
            }) && (__blocks['append'] = function(parent) {
                var args = arguments;
                return blocks['append'] ? blocks['append'].apply($this, [function() {
                    return _blocks['append'].apply($this, args);
                }].concat(__slice.call(args, 1))) : _blocks['append'].apply($this, args);
            }) && __blocks['append'].apply($this, [__noop]), 'k-append') :
            undefined,
        h('div', null, null, 'k-border')
    ], _className(function() {try {return (classNameObj )} catch(e) {_e(e)}}.call($this)))
}